import { z } from 'zod';

export const rankingRegionalItemSchema = z.object({
  anoMicrodado: z.number().nullish(),
  posicao: z.number(),
  nomeEscola: z.string(),
  qtdAlunos: z.number(),
  cidade: z.string(),
  pontuacaoEnem: z.number(),
  rankingNacional: z.number(),
  escolaAtual: z.boolean(),
});

export type RankingRegionalItem = z.infer<typeof rankingRegionalItemSchema>;

export const rankingRegionalResponseSchema = z.array(rankingRegionalItemSchema);

export type RankingRegionalResponse = z.infer<typeof rankingRegionalResponseSchema>;
